<template>
  <div
    v-if="me && shopInfo"
    id="home"
    class="col-md-12 no-padding">
    <div class="header row no-margin">
      <template v-if="device.isMobile">
        <div class="left col-6 row align-items-center no-margin">
          <div class="col no-padding">
            <span v-if="isFreeTrialLive && isUserOwner">
              {{ $t('apps.installapp.message.freetrialdaysleft', { days: getFreeTrialDaysLeft }) }}
            </span>
          </div>
        </div>
        <div class="right col-6 row align-items-center no-margin text-right">
          <div class="col no-padding">
            <div
              class="dropdown no-padding mr-2"
              style="float: right;">
              <button
                id="dropdownMenuButton"
                class="btn no-bg dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <span class="name">
                  {{ me.email || me.username }}
                </span>
                <i class="fas fa-user-circle"/>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenuButton">
                <router-link
                  v-if="me.type == 'owner' && billCount && isPricingPayAsYouGo"
                  :to="{ name: 'BillingServiceUsed' }"
                  class="dropdown-item">
                  {{ $t('message.billingdashboard') }}
                  <i class="far fa-credit-card"/>
                </router-link>
                <a
                  class="dropdown-item"
                  href="https://www.treesoft.io/th/manual/introduction"
                  target="_blank">
                  <i
                    class="fas fa-external-link-alt"
                    style="position: relative;left: -6px;"/>
                  {{ $t('message.manual') }}
                </a>
                <a
                  class="dropdown-item"
                  href="https://www.treesoft.io/th/pricing?ref=app"
                  target="_blank">
                  <i
                    class="fas fa-external-link-alt"
                    style="position: relative;left: -6px;"/>
                  {{ $t('message.treesoftpricing') }}
                </a>
                <router-link
                  v-if="me.type == 'owner' && isPricingPayAsYouGo"
                  :to="{ name: 'BillingServiceUsed' }"
                  class="dropdown-item">
                  <i
                    class="far fa-credit-card"
                    style="position: relative;left: -7px;"/>
                  {{ $t('message.billingdashboard') }}
                </router-link>
                <router-link
                  v-if="me.type == 'owner' && isPricingPackage"
                  :to="{ name: 'BillingPackageServiceUsed' }"
                  class="dropdown-item">
                  <i
                    class="fas fa-cloud-upload-alt"
                    style="position: relative;left: -7px;"/>
                  {{ $t('message.billingpackagedashboard') }}
                </router-link>
                <a
                  class="dropdown-item"
                  @click="logout">
                  <i
                    class="fas fa-power-off"
                    style="position: relative;left: -6px;"/>
                  {{ $t('message.logout') }}
                </a>
              </div>
            </div>
            <DropdownLang
              class="no-padding mr-4"
              style="float: right;"/>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="left col-3 col-sm-6 col-md-6 row align-items-center no-margin">
          <div class="col no-padding">
            <span
              v-if="shopInfo"
              class="name">{{ shopInfo.shop_name }}</span>
            <span v-if="isFreeTrialLive && isUserOwner">
              {{ $t('apps.installapp.message.freetrialdaysleft', { days: getFreeTrialDaysLeft }) }}
            </span>
          </div>
        </div>
        <div class="right col-9 col-sm-6 col-md-6 row align-items-center no-margin text-right">
          <div class="col no-padding">
            <div
              class="dropdown no-padding mr-2"
              style="float: right;">
              <button
                id="dropdownMenuButton"
                class="btn no-bg dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <span class="name">
                  {{ me.email || me.username }}
                </span>
                <i class="fas fa-user-circle"/>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenuButton">
                <template>
                  <router-link
                    v-if="me.type == 'owner' && isPricingPayAsYouGo"
                    :to="{ name: 'BillingServiceUsed' }"
                    class="dropdown-item">
                    <i
                      class="far fa-credit-card"
                      style="position: relative;left: -7px;"/>
                    {{ $t('message.billingdashboard') }}
                  </router-link>
                  <router-link
                    v-else-if="me.type == 'owner' && isPricingPackage"
                    :to="{ name: 'BillingPackageServiceUsed' }"
                    class="dropdown-item">
                    <i
                      class="fas fa-cloud-upload-alt"
                      style="position: relative;left: -7px;"/>
                    {{ $t('message.billingpackagedashboard') }}
                  </router-link>
                </template>
                <a
                  class="dropdown-item"
                  @click="logout">
                  <i
                    class="fas fa-power-off"
                    style="position: relative;left: -6px;"/>
                  {{ $t('message.logout') }}
                </a>
              </div>
            </div>
            <template>
              <div
                v-if="me.type == 'owner' && billCount && isPricingPayAsYouGo"
                class="no-padding mr-4"
                style="float: right;">
                <router-link
                  :to="{ name: 'BillingServiceUsed' }"
                  class="btn no-bg text-white">
                  <i class="far fa-credit-card"/>
                  {{ $t('message.billingdashboard') }}
                </router-link>
              </div>
              <div
                v-else-if="me.type == 'owner' && isPricingPackage"
                class="no-padding mr-4"
                style="float: right;">
                <router-link
                  :to="{ name: 'BillingPackageServiceUsed' }"
                  class="btn no-bg text-white">
                  <i class="fas fa-cloud-upload-alt"/>
                  {{ $t('message.billingpackagedashboard') }}
                </router-link>
              </div>
            </template>
            <div
              class="no-padding mr-4"
              style="float: right;">
              <a
                class="btn no-bg text-white"
                href="https://www.treesoft.io/th/manual/introduction"
                target="_blank">
                {{ $t('message.manual') }}
                <i
                  class="fas fa-external-link-alt"
                  style="font-size: 11px;"/>
              </a>
            </div>
            <div
              v-if="isPricingPayAsYouGo"
              class="no-padding mr-4"
              style="float: right;">
              <a
                class="btn no-bg text-white"
                href="https://www.treesoft.io/th/pricing?ref=app"
                target="_blank">
                {{ $t('message.treesoftpricing') }}
                <i
                  class="fas fa-external-link-alt"
                  style="font-size: 11px;"/>
              </a>
            </div>
            <DropdownLang
              class="no-padding mr-4"
              style="float: right;"/>
          <!-- <div class="dropdown no-padding" style="float: right;width: 70px;margin-right: 40px;">
            <vs-progress :height="10" :percent="40" color="success" style="position: relative; top: 6px;">success</vs-progress>
          </div> -->
          </div>
        </div>
      </template>
    </div>

    <div :class="['apps row justify-content-center', { 'suspended': isSuspended }]">
      <div
        v-if="checkAuth({ app_id: 1 })"
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ name: getModuleDefaultLink({ appId: 1, permissions: me.permissions }) }">
          <div
            :style="'background:' + $t('app.pos.bgcolor')"
            class="wraper">
            <i :class="$t('app.pos.icon')"/>
          </div>
          <span>{{ $t('app.pos.title') }}</span>
        </router-link>
      </div>
      <div
        v-if="checkAuth({ app_id: 5 })"
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ name: getModuleDefaultLink({ appId: 5, permissions: me.permissions }) }">
          <div
            :style="'background:' + $t('app.sales.bgcolor')"
            class="wraper">
            <i :class="$t('app.sales.icon')"/>
          </div>
          <span>{{ $t('app.sales.title') }}</span>
        </router-link>
      </div>
      <div
        v-if="checkAuth({ app_id: 4 })"
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ name: getModuleDefaultLink({ appId: 4, permissions: me.permissions }) }">
          <div
            :style="'background:' + $t('app.purchases.bgcolor')"
            class="wraper">
            <i :class="$t('app.purchases.icon')"/>
          </div>
          <span>{{ $t('app.purchases.title') }}</span>
        </router-link>
      </div>
      <div
        v-if="checkAuth({ app_id: 6})"
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ name: getModuleDefaultLink({ appId: 6, permissions: me.permissions }) }">
          <div
            :style="'background:' + $t('app.expenses.bgcolor')"
            class="wraper">
            <i :class="$t('app.expenses.icon')"/>
          </div>
          <span>{{ $t('app.expenses.title') }}</span>
        </router-link>
      </div>
      <div
        v-if="checkAuth({ app_id: 14 })"
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ name: getModuleDefaultLink({ appId: 14, permissions: me.permissions }) }">
          <div
            :style="'background:' + $t('app.payroll.bgcolor')"
            class="wraper">
            <i :class="$t('app.payroll.icon')"/>
          </div>
          <span>{{ $t('app.payroll.title') }}</span>
        </router-link>
      </div>
      <div
        v-if="checkAuth({ app_id: 12}) "
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ name: getModuleDefaultLink({ appId: 12, permissions: me.permissions }) }">
          <div
            :style="'background:' + $t('app.accounts.bgcolor')"
            class="wraper">
            <i :class="$t('app.accounts.icon')"/>
          </div>
          <span>{{ $t('app.accounts.title') }}</span>
        </router-link>
      </div>
      <div
        v-if="checkAuth({ app_id: 3 })"
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ ...defaultLinkInventory }">
          <div
            :style="'background:' + $t('app.inventory.bgcolor')"
            class="wraper">
            <i :class="$t('app.inventory.icon')"/>
            <div
              v-if="$store.state.app.loading && warehouses.length == 0"
              class="loading">
              <i class="fas fa-spinner spin"/>
            </div>
          </div>
          <span>{{ $t('app.inventory.title') }}</span>
        </router-link>
      </div>
      <div
        v-if="checkAuth({ app_id: 13 })"
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ name: getModuleDefaultLink({ appId: 13, permissions: me.permissions }) }">
          <div
            :style="'background:' + $t('app.hrm.bgcolor')"
            class="wraper">
            <i :class="$t('app.hrm.icon')"/>
          </div>
          <span>{{ $t('app.hrm.title') }}</span>
        </router-link>
      </div>
      <div
        v-if="checkAuth({ app_id: 11}) "
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ name: getModuleDefaultLink({ appId: 11, permissions: me.permissions }) }">
          <div
            :style="'background:' + $t('app.contacts.bgcolor')"
            class="wraper">
            <i :class="$t('app.contacts.icon')"/>
          </div>
          <span>{{ $t('app.contacts.title') }}</span>
        </router-link>
      </div>
      <div
        v-if="checkAuth({ app_id: 2 })"
        data-v-step="appid2"
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ name: getModuleDefaultLink({ appId: 2, permissions: me.permissions }) }">
          <div
            :style="'background:' + $t('app.products.bgcolor')"
            class="wraper">
            <i :class="$t('app.products.icon')"/>
          </div>
          <span>{{ $t('app.products.title') }}</span>
        </router-link>
      </div>
      <div
        v-if="checkAuth({ app_id: 8 })"
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ name: getModuleDefaultLink({ appId: 8, permissions: me.permissions }) }">
          <div
            :style="'background:' + $t('app.reports.bgcolor')"
            class="wraper">
            <i :class="$t('app.reports.icon')"/>
          </div>
          <span>{{ $t('app.reports.title') }}</span>
        </router-link>
      </div>
      <div
        v-if="me.type == 'owner' && isPricingPayAsYouGo"
        data-v-step="install-app"
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ name: 'AppsCategoryAll'}">
          <div
            :style="'background:' + $t('app.installapp.bgcolor')"
            class="wraper">
            <i :class="$t('app.installapp.icon')"/>
          </div>
          <span>{{ $t('app.installapp.title') }}</span>
        </router-link>
      </div>
      <div
        v-if="me.type == 'owner'"
        class="col-4 col-sm-3 col-md-2 item">
        <router-link :to="{ name: 'SettingsCompany'}">
          <div
            :style="'background:' + $t('app.settings.bgcolor')"
            class="wraper">
            <i :class="$t('app.settings.icon')"/>
          </div>
          <span>{{ $t('app.settings.title') }}</span>
        </router-link>
      </div>
    </div>

    <BaseModalAckFreeTrialEnded
      :id="MODAL_ACK_FREE_TRIAL"
      @onClose="handleCloseAckFreeTrialEnded"
    />

    <b-modal
      id="welcome-modal"
      size="lg"
      okOnly
      noFade
      hideHeader
      hideHeaderClose
      noCloseOnBackdrop
    >
      <div
        class="d-flex flex-column"
        style="gap: 20px;font-size: 20px;">
        <div class="row">
          <div class="col-12 mb-3">
            <strong v-html="welcomeheader" />
          </div>
          <div
            :class="[
              { 'mb-3': !isShowYoutubeVideo }
            ]"
            class="col-12"
            v-html="welcomemessage" />
          <div
            v-if="isShowYoutubeVideo"
            class="col-12 my-4">
            <div
              class="d-flex mw-100"
              style="overflow-x: auto;gap: 10px;">
              <iframe
                width="300"
                height="168.75"
                src="https://www.youtube.com/embed/9SSbmIW9e6A"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen/>
              <iframe
                width="300"
                height="168.75"
                src="https://www.youtube.com/embed/dCEuSH6bD5M"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen/>
              <iframe
                width="300"
                height="168.75"
                src="https://www.youtube.com/embed/AwtvVzTZtIs"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen/>
              <iframe
                width="300"
                height="168.75"
                src="https://www.youtube.com/embed/PRXIAJTk28Q"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen/>
              <iframe
                width="300"
                height="168.75"
                src="https://www.youtube.com/embed/xg3xcZQP9Zc"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen/>
            </div>
          </div>
          <div
            class="col-12 mb-1"
            v-html="$t('message.contactus')" />
          <!-- <div class="col-12 d-flex">
            <div class="mr-2"><i
              class="fas fa-phone-alt"
              style="color: #0088CC;" /></div>
            <div>088 599 1900, 086 411 3314</div>
          </div> -->
          <div class="col-12 d-flex">
            <div class="mr-2"><i
              class="fas fa-envelope"
              style="color: #aaa;" /></div>
            <div>contact@treesoft.io</div>
          </div>
          <div class="col-12 d-flex">
            <div class="mr-2"><i
              class="fab fa-youtube"
              style="color: #FF0000;" /></div>
            <div>TreeSoft Official</div>
          </div>
          <div class="col-12 d-flex">
            <div class="mr-2"><i
              class="fab fa-line"
              style="color: #00C300;" /></div>
            <div>@treesoft</div>
          </div>
          <div class="col-12 d-flex">
            <div class="mr-2"><i
              class="fab fa-facebook-square"
              style="color: #1877F2;"/></div>
            <div>TreeSoft.io</div>
          </div>
        </div>
      </div>
      <template #modal-footer="{ ok, cancel, hide }">
        <div class="footer">
          <button
            class="btn btn-web"
            @click="handleClickGetStarted(ok)"
          >
            {{ $t('button.getstarted') }}
          </button>
        </div>
      </template>
    </b-modal>

    <BaseModalGetDiscount
      @onSubmit="gotoGoogleForm()"
    />

    <v-tour
      :name="`tour_install_apps_first`"
      :steps="tourSteps"
      :options="tourOptions"
      :callbacks="{
        onFinish: () => onFinishTour['tour_install_apps_first']()
      }"
      class="tour_install_apps_first"
    />

    <v-tour
      :name="`tour_install_app_product_first`"
      :steps="tourSteps"
      :options="tourOptions"
      :callbacks="{
        onFinish: () => onFinishTour['tour_install_app_product_first']()
      }"
    />

    <v-tour
      :name="`tour_create_product_first`"
      :steps="tourSteps"
      :options="tourOptions"
      :callbacks="{
        onFinish: () => onFinishTour['tour_create_product_first']()
      }"
    />

    <v-tour
      :name="`tour_ready_to_use_treesoft`"
      :steps="tourSteps"
      :options="tourOptions"
      :callbacks="{
        onFinish: () => onFinishTour['tour_ready_to_use_treesoft']()
      }"
    />

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import debounce from 'debounce'
import { getModuleDefaultLink } from '@/helpers/sidebar'
import _ from 'lodash'
import BaseModalGetDiscount from '../base/BaseModalGetDiscount.vue'
import tourMinin from '@/mixins/tour'
import LocalStorage from 'store'
import DropdownLang from '../custom/DropdownLang.vue'

export default {
  name: 'Home',

  components: {
    BaseModalGetDiscount,
    DropdownLang,
  },

  mixins: [tourMinin],

  data () {
    return {
      getModuleDefaultLink,
      MODAL_ACK_FREE_TRIAL: 'MODAL_ACK_FREE_TRIAL',
      onFinishTour: {
        'tour_install_apps_first': () => {
          this.finishTour('tour_install_apps_first')
        },
        'tour_install_app_product_first': () => {
          this.finishTour('tour_install_app_product_first')
        },
        'tour_create_product_first': () => {
          this.finishTour('tour_create_product_first')
        },
        'tour_ready_to_use_treesoft': () => {
          this.finishTour('tour_ready_to_use_treesoft')
        },
      },
    }
  },

  computed: {
    ...mapGetters({
      me: 'getMe',
      warehouses: 'getWarehouses',
      shopInfo: 'getShopInfo',
      shopDiscounts: 'getShopDiscounts',
      products: 'getProducts',
    }),
    ...mapGetters([
      'getFreeTrialDaysLeft',
      'isFreeTrialLive',
      'getShopInstalledApps',
    ]),
    ...mapState('billing', {
      invoiceList: 'invoiceList',
    }),
    defaultLinkInventory () {
      let name = null
      let query = null
      const link = getModuleDefaultLink({ appId: 3, permissions: this.me.permissions })
      const isStockControlModulePage = link === null
      if (isStockControlModulePage) {
        const whId = this.warehouses.length ? this.warehouses[0].warehouse_id : null
        name = 'StockControl'
        query = { wh_id: whId }
      } else {
        name = link
      }
      return { name, query }
    },
    isSuspended () {
      return this.shopInfo.is_suspended
    },
    suspendAt () {
      if (!this.shopInfo.suspend_at) {
        return null
      }
      return this.moment(this.shopInfo.suspend_at).diff(this.moment())
    },
    suspendAtInDays () {
      if (!this.shopInfo.suspend_at) {
        return null
      }
      return this.moment(this.shopInfo.suspend_at).diff(this.moment(), 'days') + 1
    },
    unpaidInvoiceList () {
      return this.invoiceList.filter((invoice) => invoice.status === 'pending')
    },
    billCount () {
      return this.unpaidInvoiceList.length
    },
    billAmount () {
      return this.unpaidInvoiceList.reduce((acc, cur) => {
        return acc + cur.total
      }, 0)
    },
    userType () {
      return this.me.type
    },
    isUserOwner () {
      return this.userType === 'owner'
    },
    isAckFreeTrialEnded() {
      return _.get(this.shopInfo, ['acknowledge', 'web', 'freetrial_ended'])
    },
    joinedDays() {
      return this.moment(this.moment()).diff(this.me.created_at, 'days')
    },
    installedAppsCount () {
      return this.shopInfo.install_apps.length
    },
    hasInvoices() {
      return this.invoiceList.length > 0
    },
    lastInvoiceTotalInTHB() {
      let total = 0
      for (const invoice of this.invoiceList) {
        total = invoice.total
        break
      }
      return total
    },
    isShowDiscount() {
      // const expiredAt = this.moment('2025-03-05')
      // const daysLeft = expiredAt.diff(this.moment(), 'days', false)
      // const isExpired = daysLeft <= 0
      // const hasDiscount = this.shopDiscounts.some((item) => item.name === 'TreeSoft Review') === true
      // const isPaidLowPrice = this.hasInvoices && this.lastInvoiceTotalInTHB < 500
      // const shopRegisterAt = this.moment(this.shopInfo.created_at).unix()
      // const beforeRegisterAt = this.moment('2024-11-01').unix()
      // const isOldUser = shopRegisterAt < beforeRegisterAt
      // return !isExpired && !hasDiscount && isPaidLowPrice && isOldUser
      return false
    },
    welcomeheader() {
      return this.shopInfo.info.business.form_id === 1
        ? this.$t('message.welcomeheader1')
        : this.$t('message.welcomeheader2')
    },
    welcomemessage() {
      return this.shopInfo.info.business.form_id === 1
        ? this.$t('message.welcomemessage1')
        : this.$t('message.welcomemessage2')
    },
    isShowYoutubeVideo() {
      // return this.shopInfo.info.business.form_id === 1
      return false
    },
    isPricingPayAsYouGo() {
      return this.shopInfo.pricing.type == 'pay_as_you_go'
    },
    isPricingPackage() {
      return this.shopInfo.pricing.type == 'package'
    },
  },

  watch: {
    shopInfo: {
      handler: function () {
        this.checkSuspension()
      },
      immediate: true,
      deep: true,
    },
    me: {
      handler: function () {
        this.checkPermissions()
      },
      immediate: true,
      deep: true,
    },
  },

  beforeMount () {
    this.$store.dispatch('setSection', 'home')
    this.setTabTitle(this.shopInfo.shop_name)
  },

  created () {
    if (this.defaultLinkInventory.name === 'StockControl') {
      this.getWarehouses()
    }
  },

  mounted () {
    var that = this

    // set ui
    that.setUI()

    $(document).ready(function () {
      // set ui
      that.setUI()
    })

    // resize
    window.addEventListener('resize', this.handleWindowResize)

    // init freshchat
    if (window.fcWidget.isLoaded() == false) {
      window.fcWidget.init({
        token: '4b6695b3-1efe-4066-92f1-80946f07aa6b',
        host: 'https://wchat.freshchat.com',
        externalId: that.me.user_id,
      })

      if (this.me.email) {
        let that = this

        window.fcWidget.user.isExists().then(function (result) {
          if (result.data == false) {
            window.fcWidget.setExternalId(that.me.user_id)
            window.fcWidget.user.setFirstName(that.shopInfo.shop_name)
            window.fcWidget.user.setEmail(that.me.email)
          }
        })
      }
    }

    this.removeNotifies()

    if (this.$route.query.welcome == 'onboarding') {
      this.$bvModal.show('welcome-modal')
    } else {
      // notify
      this.checkServiceFeeInvoice()
      this.checkVerifyEmail()
      this.checkAckFreeTrialEnded()

      // tour
      this.checkTourInstallAppProduct()
    }
  },

  destroyed () {
    this.removeNotifies()
    window.removeEventListener('resize', this.handleWindowResize, false)
    document.querySelectorAll('.v-step').forEach((el) => el.remove())
  },

  methods: {
    ...mapActions({
      getWarehouses: 'getWarehouses',
      acknowledgeFreeTrialEnded: 'acknowledgeFreeTrialEnded',
      getShopDiscounts: 'getShopDiscounts',
    }),
    ...mapActions('billing', {
      getInvoiceList: 'getInvoiceList',
    }),
    goback () {
      this.$router.go(-1)
    },
    gotoShops () {
      this.$store.dispatch('LogoutShop')
      this.$router.push({ name: 'ChooseShop' })
    },
    logout () {
      // this.$router.push({ name: "Logout"})
      this.$store.dispatch('Logout')
    },
    switchLang (lang) {
      // change lang
      this.$i18n.locale = lang
      // switch lang
      this.$store.dispatch('switchLang', lang)
    },
    handleWindowResize (event) {
      var that = this
      setTimeout(() => {
        // set ui
        that.setUI()
      }, 10)
    },
    setUI () {
      let windowHeight = $(window).outerHeight()
      let windowWidth = $(window).outerWidth()
      let headerHeight = $('.header').outerHeight() - 50
      let appsHeight = $('.apps').outerHeight() - 50
      let appsWidth = $('.apps').outerWidth()
      let footerHeight = $('.footer').outerHeight() + 30
      let top = (windowHeight / 2) - (appsHeight / 2) - 25
      let left = (windowWidth / 2) - (appsWidth / 2)
      let appsCount = $('.apps .item').length
      let device = $('body').attr('device')

      if (appsCount <= 6) {
        top -= 40
      } else if (appsCount <= 12) {
        top -= 30
      } else {
        top -= 10
      }

      $('.apps').css({
        top: top + 'px',
        left: left + 'px',
      })
    },
    showSuspendedNotify () {
      this.notify(this.$vs, {
        title: this.$t('message.youraccounthasbeensuspended'),
        text: this.$t('message.pleasepayfortheservicetocontinueusingtreesoft'),
        color: 'suspended',
        time: 1000 * 60 * 60 * 24,
        position: 'top-center',
        click: () => this.$router.push({ name: 'BillingInvoiceList' }),
      })
    },
    showSuspendAtNotify () {
      this.notify(this.$vs, {
        title: this.$t('message.youraccountwillbesuspended', {
          date: this.getMyLocalDate(this.shopInfo.suspend_at, { short: false }),
          number: this.suspendAtInDays,
        }),
        text: this.$t('message.youraccountwillbesuspendeddetails'),
        color: 'informtosuspended',
        time: 1000 * 60 * 60 * 24,
        position: 'top-center',
        click: () => this.$router.push({ name: 'BillingInvoiceList' }),
      })
    },
    showBillingInvoiceNotify () {
      this.notify(this.$vs, {
        title: this.$t('message.youhaveservicefeetopay', {
          bill_count: this.billCount,
          amount: this.getCurrencyWithNumber(this.numberel(this.billAmount, '0,0.00')),
        }),
        text: this.$t('message.pleasepayfortheservicetocontinueusingtreesoft'),
        color: 'servicefee',
        time: 1000 * 60 * 60 * 24,
        position: 'top-center',
        click: () => this.$router.push({ name: 'BillingInvoiceList' }),
      })
    },
    showOfferDiscountNotify () {
      this.notify(this.$vs, {
        title: this.$t('message.campaign_treesoft_review_content_3'),
        text: this.$t('message.campaign_treesoft_review_modal_title') + ' -- ' + this.$t('message.campaign_treesoft_review_content_1'),
        color: 'servicefee',
        time: 1000 * 60 * 60 * 24,
        position: 'top-center',
        click: () => this.$bvModal.show('modal-discount'),
      })
    },
    removeNotifies () {
      var elements = document.querySelectorAll('.vs-notifications')
      elements.forEach((ele) => {
        ele.remove()
      })
    },
    async checkServiceFeeInvoice () {
      if (this.me.type !== 'owner') {
        return
      }

      await Promise.all([
        this.getInvoiceList({
          page: 1,
          limit: 100,
        }),
        this.getShopDiscounts(),
      ])

      if (!this.isSuspended && !this.suspendAt && this.billCount > 0) {
        this.showBillingInvoiceNotify()
      } else {
        if (this.isShowDiscount && this.isUserOwner) {
          this.showOfferDiscountNotify()
        }
      }
    },
    checkPermissions: debounce(function () {
      try {
        if (!this.isUserOwner && this.me.permissions.length == 0) {
          this.notify(this.$vs, {
            title: this.$t('message.userdonthavepermissionstitle'),
            text: this.$t('message.userdonthavepermissionsdesc', { name: this.shopInfo.shop_name }),
            color: 'veify-email',
            time: 1000 * 60 * 60 * 24,
            position: 'top-center',
          })
        }
      } catch (err) {}
    }, 1000),
    checkRecommendedInstallApp () {
      try {
        if (this.isUserOwner && this.getShopInstalledApps.length === 0) {
          this.notify(this.$vs, {
            title: this.$t('message.getstartedtitle'),
            text: this.$t('message.getstarteddesc'),
            color: 'veify-email',
            time: 1000 * 60 * 60 * 24,
            position: 'top-center',
          })
        }
      } catch (err) {}
    },
    checkSuspension: debounce(function () {
      try {
        if (this.isSuspended) {
          this.showSuspendedNotify()
        } else if (this.suspendAt > 0) {
          this.showSuspendAtNotify()
        }
      } catch (err) {}
    }, 1000),
    async checkVerifyEmail () {
      if (this.me.type !== 'owner' || this.me.verify.email) {
        return
      }

      // update user info
      await this.$store.dispatch('setLocalStorageUserInfo')

      // better ux, don't need to refresh the page the getting latest user info
      if (this.me.verify.email) {
        return
      }

      if (this.joinedDays < 1) {
        return
      }

      this.notify(this.$vs, {
        title: this.$t('message.pleaseverifyyouremail'),
        text: this.$t('message.clicktosendverifyemaillink'),
        icon: 'email',
        color: 'veify-email',
        time: 1000 * 60 * 60 * 24,
        position: 'top-center',
        click: async () => {
          const res = await this.$store.dispatch('verifyEmailSend', { email: this.me.email, lang_code: 'th' })
          if (!res.success) {
            this.notify(this.$vs, {
              text: this.$t('message.somethingwentwrong'),
              color: 'warning',
              icon: 'warning',
              time: 5000,
            })
          } else {
            this.notify(this.$vs, {
              text: this.$t('message.emailhasbeensendtoyouremailsuccess', { email: this.me.email }),
              color: 'success',
              icon: 'email',
              time: 1000 * 60 * 60 * 24,
            })
          }
        },
      })
    },
    checkAckFreeTrialEnded() {
      if (this.isUserOwner && !this.isAckFreeTrialEnded && !this.isFreeTrialLive) {
        $(`#${this.MODAL_ACK_FREE_TRIAL}`).modal('show')
      }
    },
    handleCloseAckFreeTrialEnded() {
      this.acknowledgeFreeTrialEnded()
    },
    callUs() {
      window.open('tel:0951141610')
    },
    handleClickGetStarted(ok) {
      ok()
      if (this.isPricingPayAsYouGo) {
        this.checkTourInstallApp()
      } else if (this.isPricingPackage) {
        this.checkTourInstallAppProduct()
      }
    },
    gotoGoogleForm() {
      window.open(
        `https://docs.google.com/forms/d/e/1FAIpQLSeB-YtGSN-GYPFmkUigvKtGthYQY-E2e5GIG5mMy_LQIy2GJw/viewform?usp=pp_url&entry.1015584940=${this.me.email}`,
        '_blank'
      )
    },
    async checkTourInstallApp() {
      if (this.isUserOwner && this.shopInfo.acknowledge.web.freetrial_ended == false) {
        if (this.getShopInstalledApps.length === 0) {
          if (!LocalStorage.get('tour_install_apps_first')) {
            this.tourSteps.push({
              target: '[data-v-step="install-app"]',
              header: {
                title: this.$t('message.tour_install_apps_first_title'),
              },
              content: this.$t('message.tour_install_apps_first_desc'),
            })
            this.$nextTick(() => {
              this.$tours['tour_install_apps_first'].start()
            })
          }
        }
      }
    },
    async checkTourInstallAppProduct() {
      if (this.isUserOwner && this.shopInfo.acknowledge.web.freetrial_ended == false) {
        await this.$store.dispatch('getProducts', {
          page: 1,
          limit: 1,
        })
        if (!this.isInstallApp({ app_id: 2 })) {
          if (this.products.length === 0) {
            if (!LocalStorage.get('tour_install_app_product_first')) {
              this.tourSteps.push({
                target: '[data-v-step="install-app"]',
                header: {
                  title: this.$t('message.tour_install_app_product_first_title'),
                },
                content: this.$t('message.tour_install_app_product_first_desc'),
              })
              this.$nextTick(() => {
                this.$tours['tour_install_app_product_first'].start()
              })
            }
          }
        } else {
          if (this.products.length === 0) {
            if (!LocalStorage.get('tour_create_product_first')) {
              this.tourSteps.push({
                target: '[data-v-step="appid2"]',
                header: {
                  title: this.$t('message.tour_create_product_first_title'),
                },
                content: this.$t('message.tour_create_product_first_desc'),
              })
              this.$nextTick(() => {
                this.$tours['tour_create_product_first'].start()
              })
            }
          } else {
            if (!LocalStorage.get('tour_ready_to_use_treesoft')) {
              this.tourSteps.push({
                target: null,
                header: {
                  title: this.$t('message.tour_ready_to_use_treesoft_title'),
                },
                content: this.shopInfo.info.business.form_id === 1
                  ? this.$t('message.tour_ready_to_use_treesoft_desc')
                  : this.$t('message.tour_ready_to_use_treesoft_desc_company'),
              })
              this.$nextTick(() => {
                this.$tours['tour_ready_to_use_treesoft'].start()
              })
            }
          }
        }
      }
    },
    finishTour(name) {
      LocalStorage.set(name, 'done')
    },
  },
}
</script>

<style>
  .btn:focus {
    box-shadow: none;
  }
  .vs-progress-success {
    background: #fff;
  }
  .vs-progress-background {
    border-radius: 6px;
  }
  .vs-progress-foreground {
    border-radius: 0px;
  }
  .suspended {
    opacity: 0.5;
    pointer-events: none;
  }
  .vs-notifications {
    z-index: 1039 !important;
  }
  #fc_frame, #fc_frame.fc-widget-small {
    z-index: 1 !important;
  }

  body[device="desktop"] .v-step {
    max-width: 600px !important;
  }
  body[device="mobile"] .v-step {
    max-width: 90% !important;
  }

  .v-tour.tour_install_apps_first .v-step__content {
    margin-bottom: 0;
  }
  .v-tour.tour_install_apps_first .v-step__buttons {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue